import { LoginGooglePayload } from "@ueni/users-api";
import React, { useCallback, useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import GoogleIcon from "../../../../../assets/icons/GoogleIcon";
import { BaseSocialButton } from "../BaseSocialButton";

interface Props {
  className?: string;
  onResolve: (data: LoginGooglePayload) => Promise<void>;
}

declare global {
  interface Window {
    google: any;
    onGoogleLibraryLoad: any;
  }
}

export const GoogleAuthButton = ({ className, onResolve }: Props) => {
  const googleClientId = process.env.NX_LOGIN_GOOGLE_CLIENT_ID!;
  const ref = useRef(null);

  const finishGoogleLogin = useCallback(
    async (response) => {
      const payload = {
        token_id: response.credential,
        method: "google" as const,
      };

      onResolve(payload).then();
    },
    [onResolve]
  );

  const renderButton = useCallback(() => {
    try {
      window.google.accounts.id.renderButton(ref.current, {
        theme: "filled_blue",
        size: "large",
        width: 350,
        text: "continue_with",
      });
    } catch (e) {
      console.error(e);
    }
  }, []);

  const initializeGoogleButton = useCallback(() => {
    window.google.accounts.id.initialize({
      client_id: googleClientId,
      callback: finishGoogleLogin,
    });
    renderButton();
  }, [renderButton, finishGoogleLogin, googleClientId]);

  useEffect(() => {
    if (!window.google) {
      window.onGoogleLibraryLoad = initializeGoogleButton;
    } else {
      initializeGoogleButton();
    }
  }, []);

  const onClick = useCallback(() => {}, []);

  return (
    <BaseSocialButton
      icon={<GoogleIcon />}
      text={<FormattedMessage id="login.google" />}
      onClick={onClick}
      className={className}
    >
      <div ref={ref}></div>
    </BaseSocialButton>
  );
};
